import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

import Layout from "../components/layout";

class BlogPost extends React.Component {
  render() {
    const {
      title,
      publishDate,
      publishDateJP,
      body
    } = this.props.data.contentfulBlogPost
    return(
      <Layout>
        <article>
          <h1>{title}</h1>
          <p><time dateTime={publishDate}>{publishDateJP}</time></p>
          <div dangerouslySetInnerHTML={{__html: body.childMarkdownRemark.html}} />
        </article>
      </Layout>
    )
  }
}

BlogPost.propTypes = {
  data: PropTypes.object.isRequired
}

export default BlogPost

export const pageQuery = graphql`
  query blogPostQuery($slug: String!) {
    contentfulBlogPost(slug: {eq: $slug}) {
      title
      slug
      publishDate(formatString: "YYYY-MM-DD")
      publishDateJP: publishDate(formatString: "YYYY年MM月DD日")
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`